module.exports = __webpack_public_path__ + "static/play-store-badge-d404dd8daf377453e8b52f8499e5960d.svg";